import { Box, Link } from "@mui/material";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkTable from "../../components/atoms/TkTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import "./_style.scss";
import {
  fakeTableList,
  headList,
  infoHeadTitleList,
  monthMapping,
  salaryTableHead,
  schema,
  symbolHeadList,
} from "./parts";
import { useContext, useEffect, useRef, useState } from "react";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMemo from "../../components/molecules/TkMemo";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  applyEvent,
  CommonOrCommonRetirementFlug,
  FacilityKind,
  FacilityType,
  InquiryCode,
  Prefectures,
  SexFlug,
  Status,
} from "../../assets/data/Constants";
import {
  changeAmountFormat,
  isStatusAfterApproval,
  isStatusAfterAwaitingReceipt,
} from "../../utils/useTools";
import {
  convertMonthYears,
  funInfoBodyList,
  funStatusBodyList,
  funTransferHistoryList,
} from "./hooks/useHooks";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import TkLabelText from "../../components/atoms/TkLabelText";
import TkSelectForm from "../../components/atoms/TkSelectForm";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkAmountInput from "../../components/molecules/TkAmountInput";
import { httpAPI_APP016, httpAPI_STA033, httpAPI_STA034 } from "./api/request";
import {
  IAPI_APP016_Request,
  IAPI_STA033_Request,
  IAPI_STA034_Response,
} from "../../type/apiType";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import _ from "lodash";
import { UnrecognizedMonthList } from "../../type/apiType/IAPI_STA034";

/**
 * SCRW070004 退職金追加支給時等 職員情報訂正
 * @return SCRW070004 退職金追加支給時等 職員情報訂正
 */
const SCRW070004 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [status, setStatus] = useState<any>();
  const [responseData, setResponseData] = useState<any>({});
  const location = useLocation();
  const contractorNo =
    location.state?.contractorNo ?? businessState.common?.contractorNo;
  const staffNo = location.state?.staffNo;
  const applyId = location.state?.applyId ?? businessState.job_114?.applyId;
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [selectedMonthByYear, setSelectedMonthByYear] = useState<any>({});
  const [selectedMonth, setSelectedMonth] = useState<any>([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [isOpen, setIsOpen] = useState(false);
  const selectReson = useRef<any>(null);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  type ISixSalary = {
    yearMonth?: number; // 年月
    salaryTableAmt?: number; // 俸給表の額
    salaryAdjustmentAmt?: number; // 俸給の調整額
    errorSalaryTableAmt?: string;
    errorSalaryAdjustmentAmt?: string;
  };
  const [sixMonthsSalaryBeforeApplyList, setSixMonthsSalaryBeforeApplyList] =
    useState<ISixSalary[] | undefined>([]);
  const submitDisabled = sixMonthsSalaryBeforeApplyList?.some?.(
    (item) => !!item?.errorSalaryTableAmt || !!item?.errorSalaryAdjustmentAmt
  );

  // 初期化
  const handleInit = async () => {
    try {
      const res = await httpAPI_STA034({
        contractorNo,
        staffNo,
        applyId,
      });

      if (res.resultCd === "I0000") {
        setResponseData(res);
        setStatus(res.latestApplyStatus);

        const handleLinkClick = (isContractor?: boolean) => {
          setBusinessState({
            ...businessState,
            job_114: {
              ...businessState.job_114,
              applyId,
              facilityNo: res.facilityNo,
            },
          });

          if (isContractor) {
            navigate("/SCRC040101");
          } else {
            navigate("/SCRW120004", { state: { facilityNo: res.facilityNo } });
          }
        };

        const resArr = stateFakeTableList.current;

        // １段目
        // 契約者番号
        resArr.find((item) => item.keyword === "contractorNo")!.text =
          res.contractorNo;
        // 契約者名にリンクを付与
        resArr.find((item) => item.keyword === "contractorName")!.node = (
          <Link onClick={() => handleLinkClick(true)}>
            {res.contractorNo}:{res.corpName}
          </Link>
        );
        // 契約者住所
        resArr.find((item) => item.keyword === "contractorAddress")!.text = (
          <>
            〒{res.cozipcode}
            {TkGetCode(Prefectures, res.coprefectureCd)}
            {res.coaddressCity}
            {res.coaddressOthers}
          </>
        );
        // TEL
        resArr.find((item) => item.keyword === "tel")!.text = res.tel;
        // FAX
        resArr.find((item) => item.keyword === "fax")!.text = res.fax;

        // ２段目
        // 施設番号
        resArr.find((item) => item.keyword === "facilityNo")!.text =
          res.facilityNo;
        // 施設名称
        resArr.find((item) => item.keyword === "facilityName")!.node = (
          <Link onClick={() => handleLinkClick()}>{res.facilityName}</Link>
        );
        // 施設住所
        resArr.find((item) => item.keyword === "facilityAddress")!.text = (
          <>
            〒{res.zipcode}
            {TkGetCode(Prefectures, res.prefectureCd)}
            {res.addressCity}
            {res.addressOthers}
          </>
        );
        // 施設種類
        resArr.find((item) => item.keyword === "facilityType")!.text =
          TkGetCode(FacilityKind, res.facilityKind);
        // 施設区分
        resArr.find((item) => item.keyword === "facilityKbn")!.text = TkGetCode(
          FacilityType,
          res.facilityKbn
        );

        // ３段目
        // 職員名
        resArr.find(
          (item) => item.keyword === "staffName"
        )!.text = `${res.staffNo}: ${res.staffNameKanji}`;
        // 性別
        resArr.find((item) => item.keyword === "gender")!.text = TkGetCode(
          SexFlug,
          res.sex
        );
        // 職種
        resArr.find((item) => item.keyword === "jobCd")!.text = res.jobName;
        // 生年月日
        resArr.find((item) => item.keyword === "birthday")!.text = res.birthday;
        // 初回加入年月日
        resArr.find((item) => item.keyword === "joinDate")!.text =
          res.firstJoinDate;
        // 被共済職員期間
        resArr.find((item) => item.keyword === "premiumEnroll")!.text =
          (res.maePeriodYear ?? "") +
          "年" +
          (res.maePeriodMonth ?? "") +
          "ヶ月";
        // 退職日
        resArr.find((item) => item.keyword === "retireDate")!.text =
          res.retireDate;
        // 支給額
        resArr.find((item) => item.keyword === "paymentAmt")!.text =
          res.paymentAmt ? changeAmountFormat(res.paymentAmt) + "円" : "";
        // 俸給表の額
        resArr.find((item) => item.keyword === "salaryTableAmt")!.text =
          res.salaryTableAmt !== undefined && res.salaryTableAmt !== null
            ? changeAmountFormat(res.salaryTableAmt) + "円"
            : "";
        // 俸給の調整額
        resArr.find((item) => item.keyword === "salaryAdjustmentAmt")!.text =
          res.salaryAdjustmentAmt !== undefined &&
          res.salaryAdjustmentAmt !== null
            ? changeAmountFormat(res.salaryAdjustmentAmt) + "円"
            : "";
        // 合計
        resArr.find((item) => item.keyword === "totalPaymentAmt")!.text =
          res.totalPaymentAmt !== undefined && res.totalPaymentAmt !== null
            ? changeAmountFormat(res.totalPaymentAmt) + "円"
            : "";

        // 訂正後
        // 被共済職員期間（職員情報訂正後）
        resArr.find(
          (item) => item.keyword === "correctedMutualAidPeriod"
        )!.node = (
          <Box className="line">
            <TkLabelText
              wantToSetValue={res.maePeriodYearAfter}
              disabled={true}
            />
            年
            <TkLabelText
              wantToSetValue={res.maePeriodMonthAfter}
              disabled={true}
            />
            ヶ月
          </Box>
        );

        // 俸給表の額（職員情報訂正後）
        resArr.find(
          (item) => item.keyword === "correctedSalaryTableAmt"
        )!.setDefaultValue = res.salaryTableAmtAfter;

        // 俸給の調整額（職員情報訂正後）
        resArr.find(
          (item) => item.keyword === "correctedSalaryAdjustmentAmt"
        )!.setDefaultValue = res.salaryAdjustmentAmtAfter;

        // 合計（職員情報訂正後）
        resArr.find(
          (item) => item.keyword === "correctedSum"
        )!.setDefaultValue = res.totalPaymentAmtAfter;

        // 支給額（職員情報訂正後）
        let paymentAmtAfter = resArr.find(
          (item) => item.keyword === "correctedPaymentAmt"
        )!;
        paymentAmtAfter.setDefaultValue = res.paymentAmtAfter;
        // 追加支給額/返還額
        let addCorrectedPaymentAmt = resArr.find(
          (item) => item.keyword === "addCorrectedPaymentAmt"
        )!;
        addCorrectedPaymentAmt.setDefaultValue = res.addPaymentAmt;
        // 追加支給/返還理由
        let reason = resArr.find((item) => item.keyword === "reason")!;
        reason.setDefaultValue = res.addPaymentReason;
        selectReson.current = res.addPaymentReason;
        reason.onGetValue = (value: any) => {
          selectReson.current = value;
        };
        if (
          isStatusAfterAwaitingReceipt(res.latestApplyStatus) ||
          res.latestApplyStatus === Status["受理待ち"]
        ) {
          reason.disabled = true;
          reason.requiredIcon = false;
        } else {
          reason.disabled = false;
          reason.requiredIcon = true;
        }

        const bodyList: any = [
          [
            {
              children: res.symbolNo,
            },
            {
              children: res.decisionDate,
            },
          ],
        ];

        // 異動履歴
        const transferHistoryList = funTransferHistoryList(
          res.movementHistoryList
        );
        resArr.find((item) => item.keyword === "transferHistoryList")!.node = (
          <Box className="SCRC070004tblList">
            <TkFakeTableLine
              title="異動履歴"
              type="multipleLinesWithBorder"
              dataList={transferHistoryList}
            />
          </Box>
        );

        // 育休テーブル
        const infoBodyList = funInfoBodyList(res.childcareLeaveList);
        resArr.find((item) => item.keyword === "childcareLeaveList")!.node = (
          <Box className="SCRC070004tblList">
            <TkTable bodyList={infoBodyList} headList={infoHeadTitleList} />
          </Box>
        );

        // 処理履歴
        const statusList = funStatusBodyList(res.statusList);
        resArr.find((item) => item.keyword === "statusList")!.node = (
          <Box className="SCRC070004tblList">
            <TkTable bodyList={statusList} headList={headList} />
          </Box>
        );

        // メモ
        const isBodylistVisible = isStatusAfterApproval(res.latestApplyStatus);
        resArr.find((item) => item.keyword === "memo")!.node = (
          <Box className="SCRC070004tblList">
            <TkMemo headList={headList} showTable={true} onChange={onChange} />
            {isBodylistVisible && (
              <TkTableWithNoLine
                headList={symbolHeadList}
                bodyList={bodyList}
              />
            )}
          </Box>
        );
        setSixMonthsSalaryBeforeApplyList(res.sixMonthsSalaryBeforeApplyList);
        setStateTableList(resArr);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const deSalary = useRef<any>(
    _.debounce((data: any, newError, index) => {
      setSixMonthsSalaryBeforeApplyList((prev) => {
        if (!prev) {
          return prev;
        }
        const newSixMonthsSalaryBeforeApplyList = [...prev];
        newSixMonthsSalaryBeforeApplyList[index].salaryTableAmt =
          data.target.value;
        newSixMonthsSalaryBeforeApplyList[index].errorSalaryTableAmt = newError;
        return newSixMonthsSalaryBeforeApplyList;
      });
    }, 300)
  );

  const deSalaryAdjustment = useRef<any>(
    _.debounce((data: any, newError, index) => {
      setSixMonthsSalaryBeforeApplyList((prev) => {
        if (!prev) {
          return prev;
        }
        const newSixMonthsSalaryBeforeApplyList = [...prev];
        newSixMonthsSalaryBeforeApplyList[index].salaryAdjustmentAmt =
          data.target.value;
        newSixMonthsSalaryBeforeApplyList[index].errorSalaryAdjustmentAmt =
          newError;
        return newSixMonthsSalaryBeforeApplyList;
      });
    }, 300)
  );

  useEffect(() => {
    if (!responseData || !responseData.contractorNo) {
      handleInit();
    }

    const currentDeSalary = deSalary.current;
    const currentDeSalaryAdjustment = deSalaryAdjustment.current;
    return () => {
      currentDeSalary.cancel();
      currentDeSalaryAdjustment.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeSalaryTableAmt = (data: any, index: number, type?: string) => {
    let salaryTableAmt = data.target.value;
    let newError: string;
    if (salaryTableAmt > 999999999) {
      newError = TkPropertyMessageGet("TKMSG_SCR0048E", "999,999,999");
    } else if (
      salaryTableAmt === null ||
      salaryTableAmt === undefined ||
      salaryTableAmt === ""
    ) {
      newError = TkPropertyMessageGet("TKMSG_SCR0043E");
    } else if (salaryTableAmt < -999999999) {
      newError = TkPropertyMessageGet("TKMSG_SCR0047E", "-999,999,999");
    } else if (!/^\d+$/.test("" + salaryTableAmt)) {
      newError = TkPropertyMessageGet("TKMSG_SCR0053E");
    } else {
      newError = "";
    }
    if (type === "salaryAdjustmentAmt") {
      deSalaryAdjustment.current(data, newError, index);
    } else {
      deSalary.current(data, newError, index);
    }
  };

  /**
   * 俸給テーブルを作成する
   * @param sixSalaryList
   * @param disable
   * @returns salaryBodyList
   */
  function funSalaryBodyList(
    sixSalaryList: ISixSalary[] | undefined,
    disable: boolean
  ) {
    if (!sixSalaryList) {
      sixSalaryList = [];
    }
    const salaryBodyList: any[] = [];
    let montYearsArr = convertMonthYears(selectedMonth, selectedYear);
    for (let i = 0; i < sixSalaryList.length; i++) {
      let yearMonth = sixSalaryList[i]?.yearMonth;
      if (yearMonth && montYearsArr.includes(yearMonth.toString())) {
        continue;
      }
      const data = [
        {
          children:
            sixSalaryList[i].yearMonth?.toString().slice(0, 4) +
            "年" +
            sixSalaryList[i].yearMonth?.toString().slice(4) +
            "月",
        },
        {
          children: (
            <TkAmountInput
              error={!!sixSalaryList[i].errorSalaryTableAmt}
              errorMessage={sixSalaryList[i].errorSalaryTableAmt}
              wantToSetValue={sixSalaryList[i].salaryTableAmt}
              disabled={disable}
              onChange={(e: any) => changeSalaryTableAmt(e, i)}
            />
          ),
          align: "right",
        },
        {
          children: (
            <TkAmountInput
              error={!!sixSalaryList[i].errorSalaryAdjustmentAmt}
              errorMessage={sixSalaryList[i].errorSalaryAdjustmentAmt}
              wantToSetValue={sixSalaryList[i].salaryAdjustmentAmt}
              disabled={disable}
              onChange={(e: any) =>
                changeSalaryTableAmt(e, i, "salaryAdjustmentAmt")
              }
            />
          ),
          align: "right",
        },
      ];

      salaryBodyList.push(data);
    }

    return salaryBodyList;
  }

  useEffect(() => {
    let newStateTableList = stateFakeTableList.current;
    newStateTableList.find(
      (item: any) => item.keyword === "unrecognizedMonthList"
    )!.node = renderUnrecognizedMonthList();

    // 俸給テーブル
    let salaryBodyList = funSalaryBodyList(
      sixMonthsSalaryBeforeApplyList,
      responseData.latestApplyStatus !== "00" &&
        responseData.latestApplyStatus !== "16"
    );
    newStateTableList.find((item) => item.keyword === "salaryTableList")!.node =
      (
        <Box className="SCRC070004tblList">
          <TkTable bodyList={salaryBodyList} headList={salaryTableHead} />
        </Box>
      );
    setStateTableList([...newStateTableList]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedMonth,
    responseData,
    selectedYear,
    sixMonthsSalaryBeforeApplyList,
  ]);

  /**
   * ならない月を作成する
   * 配列をループして各要素に対してUI要素を生成する関数
   * @returns renderUnrecognizedMonthList
   */
  const renderUnrecognizedMonthList = () => {
    let res: IAPI_STA034_Response = _.cloneDeep(responseData);

    const disable = !(
      res.latestApplyStatus === Status["届出待ち"] ||
      res.latestApplyStatus === Status["差戻し一時保存"]
    );

    let selectYears =
      res.unrecognizedMonthList?.map((item: any) => ({
        value: item.year?.toString(),
        label: item.year?.toString() + "年",
      })) ?? [];

    let currentMonthArr: UnrecognizedMonthList | undefined;
    if (selectedYear) {
      currentMonthArr = res.unrecognizedMonthList?.find(
        (item: any) => item.year === Number(selectedYear)
      );
    } else {
      currentMonthArr = res.unrecognizedMonthList?.[0];
    }
    let monthArr = Object.values(currentMonthArr ?? {}).slice(1);
    monthArr = monthArr.map((item: any, index: number) => {
      if (selectedMonth[index] === "1") {
        return "1";
      }
      return item;
    });

    // ★以下2箇所のsetStateが毎回実行されるため無限ループ発生
    // ★対策：状態が変化する場合のみsetStateを行う
    if (!_.isEqual(selectedMonthByYear[selectedYear], monthArr)) {
      setSelectedMonthByYear((prev: any) => ({
        ...prev,
        [selectedYear]: monthArr,
      }));
    }

    if (!_.isEqual(selectedMonth, monthArr)) {
      setSelectedMonth(monthArr);
    }

    monthArr = monthArr.map((item: any, index: number) => {
      if (selectedMonth[index] === "1") {
        return "1";
      }
      return item;
    });

    const monthNode = (
      <Box>
        <Box className="part">
          <TkSelectForm
            selectPropsList={selectYears}
            wantToSetValue={
              res.unrecognizedMonthList && res.unrecognizedMonthList.length > 0
                ? res.unrecognizedMonthList[
                    res.unrecognizedMonthList.length - 1
                  ]?.year
                : ""
            }
            onChange={(e: any) => {
              setSelectedYear(e.target.value);
              const newYear = e.target.value;
              const newMonthArr =
                res.unrecognizedMonthList?.find(
                  (item: any) => item.year === Number(newYear)
                ) ?? {};
              const savedMonthArr =
                selectedMonthByYear[newYear] ||
                Object.values(newMonthArr).slice(1);
              // ★ここでは既にsetSelectedMonthByYear済みなため状態更新不要
              // setSelectedMonth(savedMonthArr)はselectedYear変更時に必要なため残す
              if (!_.isEqual(selectedMonth, savedMonthArr)) {
                setSelectedMonth(savedMonthArr);
              }
            }}
          />
        </Box>
        <Box>
          <TkCheckbox
            label="無"
            disabled
            checked={monthArr.every((m) => m === "0" || m === "2")}
            value="0"
          />
          {Object.values(monthMapping).map((month: any, index: number) => {
            return (
              <TkCheckbox
                label={`${month} 月`}
                disabled={disable || monthArr[index] === "2"}
                checked={monthArr[index] === "1" || monthArr[index] === "3"}
                key={index}
                value={month}
                onChange={(e: any) => changeMonth(e, index, monthArr)}
              />
            );
          })}
        </Box>
      </Box>
    );

    return (
      <Box className="SCRC070004tblList">
        <TkFakeTableLine
          title="ならない月"
          type="nodeInLine"
          node={monthNode}
        />
      </Box>
    );
  };

  const changeMonth = (e: any, index: number, monthArr: any) => {
    if (e.target.checked) {
      monthArr[index] = "1";
    } else {
      monthArr[index] = "0";
    }
    setSelectedMonth([...monthArr]);
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  // データを作成
  const makeHttpObj = (num: string, formData?: any): IAPI_APP016_Request => {
    const req: IAPI_APP016_Request = {
      applyId: applyId,
      applyEvent: num,
      contractorNo: contractorNo,
      screenId: "SCRW070004",
      inquiryCode: memoCheck ? InquiryCode["職員"] : "",
      reason: memoData,
    };
    if (formData?.symbolNumber) {
      req.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      req.decisionDate = formData.settlementDate;
      req.dueDate = formData.paymentDeadline;
    }

    return req;
  };

  const btnEvent = async (btnName: keyof typeof applyEvent) => {
    if (submitDisabled) return;

    const event = applyEvent[btnName];

    switch (event) {
      case applyEvent["契約者に差戻し"]:
      case applyEvent["受理"]:
      case applyEvent["担当者に差戻し"]:
      case applyEvent["課長代理確認"]:
      case applyEvent["上長承認"]:
      case applyEvent["郵送"]:
        handleSave(event);
        break;
      case applyEvent["承認"]:
        setIsOpen(true);
        break;
    }
  };

  const handleSave = async (applyEvent: any, formData?: any) => {
    // 申請状況更新API
    try {
      const res = await httpAPI_APP016({
        ...makeHttpObj(applyEvent, formData),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setOpen = () => {
    setIsOpen(false);
  };

  const makeHttpObjSearch = (): IAPI_STA033_Request => {
    // 申請前6か月間の本俸月額リスト
    const sixMonthsSalaryBeforeApplyList = (
      (responseData.sixMonthsSalaryBeforeApplyList as IAPI_STA034_Response["sixMonthsSalaryBeforeApplyList"]) ||
      []
    ).map((item) => ({
      yearMonth: item?.yearMonth,
      salaryTableAmt: item?.salaryTableAmt,
      salaryAdjustmentAmt: item?.salaryAdjustmentAmt,
      monthlySalaryAmt:
        (item.salaryTableAmt || 0) + (item.salaryAdjustmentAmt || 0),
    }));
    const unrecognizedMonthListForRequest =
      responseData.unrecognizedMonthList?.map((item: any) => {
        const selectedMonths = selectedMonthByYear[item.year] || [
          item.apr,
          item.may,
          item.jun,
          item.jul,
          item.aug,
          item.sep,
          item.oct,
          item.nov,
          item.dec,
          item.jan,
          item.feb,
          item.mar,
        ];
        const res: { [key: string]: string } = {
          year: item.year,
          apr: selectedMonths[0],
          may: selectedMonths[1],
          jun: selectedMonths[2],
          jul: selectedMonths[3],
          aug: selectedMonths[4],
          sep: selectedMonths[5],
          oct: selectedMonths[6],
          nov: selectedMonths[7],
          dec: selectedMonths[8],
          jan: selectedMonths[9],
          feb: selectedMonths[10],
          mar: selectedMonths[11],
        };
        Object.keys(res).forEach((key) => {
          if (key !== "year") {
            if (res[key] === "2") {
              res[key] = "0";
            } else if (res[key] === "3") {
              res[key] = "1";
            }
          }
        });
        return res;
      });

    return {
      contractorNo: contractorNo,
      staffNo: responseData.staffNo,
      unrecognizedMonthList: unrecognizedMonthListForRequest,
      sixMonthsSalaryBeforeApplyList,
      updateDateTime: responseData.updateDateTime,
      applyId: responseData.applyId,
      facilityNo: responseData.facilityNo,
      retireDate: responseData.retireDate,
      maePeriodYear: 0,
      maePeriodMonth: 0,
      totalPaymentAmt: 0,
      addPaymentAmt: 0,
      addPaymentReason: selectReson.current,
      screenId: "SCRW070004",
    };
  };

  const onCheckAndSubmit = async () => {
    if (submitDisabled) return;
    if (
      sixMonthsSalaryBeforeApplyList?.find(
        (stasixMonthsSalaryBeforeApplyteStaff) =>
          stasixMonthsSalaryBeforeApplyteStaff?.salaryTableAmt &&
          stasixMonthsSalaryBeforeApplyteStaff?.salaryTableAmt <= 73999
      )
    ) {
      // 俸給表の額 ≦ 73,999円
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0124E",
      });
      return;
    }
    try {
      // 退職手当金追加更新
      const res = await httpAPI_STA033({
        ...makeHttpObjSearch(),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW070004PageForTest" className="SCRW070004">
      {/* 承認フロー */}
      {status !== "00" && status !== "16" && (
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType={responseData?.businessType}
          corporateApplicationClassification={responseData?.corpApplyKbn}
          applicationStatus={status}
        />
      )}
      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        buttonGroup={
          <Box>
            <TkBackButton
              mr
              useBackParam
              navigateParam={{
                applyId,
                contractorNo,
              }}
            />
            {status !== "00" && status !== "16" && (
              <TkViewButtonJudgement
                flowType={"TYPE2"}
                Status={status}
                onClick={btnEvent}
              />
            )}
          </Box>
        }
        showButton={status === "00" || status === "16"}
        submitButtonText="申請"
        onCheckAndSubmit={onCheckAndSubmit}
      />
      <TkApprovalDateSymbolNumberRegistrationDialog
        open={isOpen}
        onSuccess={(e: any) => handleSave(applyEvent["承認"], e)}
        onClose={setOpen}
        isScheduledPaymentDateVisible={false}
        displayOnlyPaymentDeadline={true}
      />
    </Box>
  );
};

export default SCRW070004;
